// removed by extract-text-webpack-plugin
module.exports = {"vpUpgradePopover":"vpUpgradePopover___1HvPx","vpLockedContent":"vpLockedContent___36fRj","vpLock":"vpLock___3HU6P"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LockableContent/LockableContent.module.less
// module id = 3285
// module chunks = 29